import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody";

export default function TransitionTubeMaterial({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionPileheads.transitionTubeMaterial")}</p>}
      inputValue={<span className="input">{value}</span>}
    />
  );
}
